<template>
  <div class="c-entrepreneur-parallax-small" :class="{ '-no-bg': hideBackground }">
    <card-thumbnail v-view.reveal="{ handler: viewParallax, delay: 1 }" :image="data.small_image" bg="bright" />
  </div>
</template>

<script>
import Variables from "src/mixins/variables";
import CardThumbnail from "objects/Card/CardThumbnail";

import gsap from "gsap";

export default {
  components: {
    CardThumbnail
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    hideBackground: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    x(x) {
      gsap.to(this.$el, {
        duration: 0.2,
        x: x,
        ease: "sine.out"
      });
    },
    y(y) {
      gsap.to(this.$el, {
        duration: 0.2,
        y: y,
        ease: "sine.out"
      });
    },
    isHorizontal(horizontal) {
      if (horizontal) {
        this.y = 0;
      } else {
        this.x = 0;
      }
    }
  },
  mixins: [Variables],
  data() {
    return {
      x: 0,
      y: 0
    };
  },
  methods: {
    viewParallax(e) {
      if (this.isHorizontal) {
        this.x = ((e.percent.center.x - 0.75) * this.W.w) / 10;
      } else {
        this.y = ((e.percent.center.y - 0.5) * this.W.h) / 15;
      }
    }
  }
};
</script>

<style lang="scss">
.c-entrepreneur-parallax-small {
  display: flex;
  flex-direction: row;
  height: 100%;
  align-items: center;
  justify-content: center;
  z-index: 9;

  @media #{$breakpoint-vertical} {
    justify-content: flex-start;
    padding-left: calc((100vw - #{$card-max-width}) / 2);

    .c-card {
      width: #{$card-max-width * 0.5};
      max-width: #{$card-max-width * 0.5};
      --corner-size: 2.5rem;
    }
  }

  @media #{$breakpoint-horizontal} {
    position: absolute;
    top: 0px;
    left: -25%;
  }

  &.-no-bg {
    .o-asset,
    .c-card__inner {
      background-color: transparent;
    }

    @media #{$breakpoint-horizontal} {
      left: 0;
    }
  }
}
</style>
